import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * `cn` — class-name merger used by every shadcn primitive.
 * Combines `clsx` (conditional classes) with `tailwind-merge`
 * (last-wins deduplication of conflicting Tailwind utilities, so a
 * caller's `className` always wins over a default without having to
 * remember which utility beats which).
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
